import DynamicSectionElement from '@/scripts/dynamic-section-element.js'
import { trapFocus, removeTrapFocus } from '@shopify/theme-a11y'
import { handleLinksClick } from '@/scripts/datalayer'
import { handleArrowDown, handleArrowUp } from '@/scripts/accessibility'
import { decode } from '@/scripts/utils'

class MenuSlideout extends DynamicSectionElement {
  constructor () {
    super()

    this.addEventListener('keyup', (event) => {
      const eventCode = event.code.toUpperCase()
      const body = document.body
      const menuBarEl = document.querySelector('.js-menu-bars')
      if (eventCode === 'ESCAPE') {
        if (body.classList.contains('is-open-menu-level-2')) {
          this.focusActiveMenuLevel1()
          const arialabel1Els = document.querySelectorAll('.js-menu-level-1 button.js-open-menu-level-3')
          this.resetAriaExpanded(arialabel1Els)
          this.hiddenMenuLevel('is-open-menu-level-2')
        } else {
          this.closeDrawer()
          trapFocus(menuBarEl)
        }
      }
      const el = event.target
      if (eventCode === 'SPACE' ) {
        if (el.classList.contains('js-open-menu-level-2')) {
          this.setAriaExpandedButton(el, true)
          document.querySelector('menu-slideout').openChildMenu(el)
          this.focusMenuLevel2()
        }
      }

      if (el.closest('.js-menu-level-1')) {
        if (eventCode === 'ARROWDOWN') {
          handleArrowDown(el, this)
        }

        if (eventCode === 'ARROWUP') {
          handleArrowUp(el, this)
        }
      }

      if (el.closest('.js-menu-level-2')) {
        const menuLevel2El = el.closest('.js-menu-level-2')
        if (eventCode === 'ARROWDOWN') {
          handleArrowDown(el, menuLevel2El)
        }

        if (eventCode === 'ARROWUP') {
          handleArrowUp(el, menuLevel2El)
        }
      }
    })
  }

  toggle (event) {
    const buttonEl = event.target.closest('button')
    const menuSlideoutEl = document.querySelector('menu-slideout')
    if (buttonEl.getAttribute('aria-expanded') === 'true') {
      this.closeDrawer()
    } else {
      this.openDrawer(event)
      trapFocus(menuSlideoutEl)
    }
  }

  openDrawer (event) {
    if (event && event.preventDefault) {
      if (event.metaKey) {
        return
      }
      event.preventDefault()
    }
    const buttonEl = event.target.closest('button')
    if (buttonEl && buttonEl.classList.contains('js-menu-bars')) {
      buttonEl.setAttribute('aria-expanded', 'true')
    }

    this.classList.add('open-slideout')
    document.body.classList.add('overflow-hidden')
    if (event && event.currentTarget) {
      const activeHandle = this.querySelector(`[data-handle="${event.currentTarget.dataset.handle}"]`)
      this.openChildMenu(activeHandle)
    }
  }

  closeDrawer () {
    this.classList.remove('open-slideout')
    document.body.classList.remove('overflow-hidden', 'is-open-slideout', 'is-open-menu-level-2' )
    document.querySelector('.js-menu-bars').setAttribute('aria-expanded', 'false')

    removeTrapFocus()
  }

  openChildMenu (element) {
    if (element && element.dataset.hasSubmenu) {

      const current = element.dataset.menuTitle
      const menuLevel2El = document.querySelector('.js-menu-level-2')
      document.querySelector('.js-selected-menu-level-2').textContent = current
      document.querySelector('.js-selected-menu-level-2').parentNode.setAttribute('aria-label', `Close ${current} submenu`)
      const contentEl = document.querySelector('.js-content-menu-level-2')
      console.log('element.nextSibling', element.nextSibling)
      const menuItemEl = element.closest('.js-menu-item-level-1')
      let htmlItem = menuItemEl.querySelector('.js-data-menu').innerHTML

      const dataMenuHTML = `
        <div class="flex flex-col w-full">${htmlItem}</div>
        `
      contentEl.innerHTML = dataMenuHTML

      this.resetAllActiveMenuLevel('.js-menu-item')
      const parentEl = element.parentElement
      parentEl.classList.add('active')
      this.openMenuLevel('is-open-menu-level-2')
      trapFocus(menuLevel2El)
    }
  }

  resetAllActiveMenuLevel (className) {
    const menuItemEls = document.querySelectorAll(className)
    menuItemEls.forEach(item => {
      if (item.classList.contains('active')) {
        item.classList.remove('active')
      }
    })
  }

  focusMenuLevel2 () {
    const childEls = document.querySelectorAll('.js-menu-item-level-2')
    const containerEl = document.querySelector('.js-content-menu-level-2')
    trapFocus(containerEl, {
      elementToFocus: childEls[0].querySelector('a')
    })
  }

  focusActiveMenuLevel2 () {
    const childActiveEl = document.querySelector('.js-menu-item-level-2.active')
    const containerEl = document.querySelector('.js-content-menu-level-2')
    trapFocus(containerEl, {
      elementToFocus: childActiveEl.querySelector('a')
    })
  }

  focusActiveMenuLevel1 () {
    const childActiveEl = document.querySelector('.js-menu-item-level-1.active')
    const containerEl = document.querySelector('.js-menu-level-1')
    trapFocus(containerEl, {
      elementToFocus: childActiveEl.querySelector('a')
    })
  }

  openMenuLevel(className) {
    const body = document.body
    if (!body.classList.contains(className)) {
      body.classList.add(className)
    }
  }

  resetAriaExpanded(el) {
    el.forEach(item => {
      this.setAriaExpandedButton(item, false)
    })
  }

  setAriaExpandedButton (el, value) {
    if (el.hasAttribute('aria-expanded')) {
      el.setAttribute('aria-expanded', value)
    }
  }

  hiddenMenuLevel(className) {
    const body = document.body
    if (body.classList.contains(className)) {
      body.classList.remove(className)
    }
  }

  hiddenMenuLevel2() {
    this.hiddenMenuLevel('is-open-menu-level-2')
    this.focusActiveMenuLevel1()
  }
}

customElements.define('menu-slideout', MenuSlideout)
